import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBIcon
  } from 'mdbreact';
  import { api } from '../../api';
  import Swal from 'sweetalert2'

export default class ModaleditstatusNo extends Component {
    constructor(props) {
        super(props);
this.state = {
    modal: false,
    id_room:'',
    numberroom:'',
    comment:'',

}

 this.updatestatusopenroom = this.updatestatusopenroom.bind(this);
 this.onTextChange = this.onTextChange.bind(this);
// this.handleChange3 = this.handleChange3.bind(this);
// this.handleSubmit = this.handleSubmit.bind(this);
// this.toggle = this.toggle.bind(this);
// this.handleChange4 = this.handleChange4.bind(this);
//this.getExpert = this.getExpert.bind(this);
}

toggle = () => {
    this.setState({
      modal: !this.state.modal,
      id_room: this.props.id_room ,
     // numberroom: this.props.numberroom
    });
  }


  onTextChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  updatestatusopenroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);
      datafrm.append("comment", this.state.comment);
      api.post("lkupdatestatusroomNo.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'แจ้งห้องไม่พร้อมรับสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                          //  this.props.getroom();
                            this.toggle();
                           // this.getwork();
                            window.location.href = '/Homelucky'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }


  render() {
    console.log(this.state.id_room)
    return (
      <MDBContainer >
        
        <MDBBtn color="unique" onClick={this.toggle}><MDBIcon icon="chalkboard-teacher" /> ห้องไม่พร้อมรับ</MDBBtn>
     <div className='text-center'>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader toggle={this.toggle}>จัดการห้อง </MDBModalHeader>

          <MDBModalBody>
          <h3>ห้องที่ {this.props.numberroom}</h3> 
          <div className="mb-2">
                                      <label className="font-weight-bold">! เหตุผล</label>
                                      <input className="form-control" onChange={this.onTextChange} name="comment"
                                          value={this.state.comment} placeholder=""  />
                                  </div>

          <MDBBtn color="unique" onClick={this.updatestatusopenroom}><MDBIcon icon="bed" /> ห้องไม่พร้อมรับ</MDBBtn>
          </MDBModalBody>

          <MDBModalFooter>
            <MDBBtn color="secondary" size="sm" onClick={this.toggle}>ปิด</MDBBtn>
            {/* <MDBBtn color="primary" size="sm">Save changes</MDBBtn> */}
          </MDBModalFooter>
        </MDBModal>
      </div>  
      </MDBContainer>
    )
  }
}
